import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import LoadingScreen from '../../../components/LoadingScreen';

const StudentWalletsListComponent = React.lazy(() => import('./components/StudentWalletsList'));

const StudentWalletsList = () => {
  const { pathname } = useLocation();

  return (
    <div>
      <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
        <StudentWalletsListComponent />
      </Suspense>
    </div>
  );
}

export default StudentWalletsList;
